import { yupResolver } from '@hookform/resolvers/yup';
import { CircularProgress, Container, Grid } from '@mui/material';
import { t } from 'i18next';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { GET_SETTING, UPDATE_SETTING } from 'src/apiService/apiDeclaration';
import CustomTextField from 'src/components/formFields/textField';
import LoaderButton from 'src/components/loaderButton/loaderButton';
import PageHeader from 'src/components/pageHeader/PageHeader';
import { updateSettingSchema } from 'src/config/yup';
import { showErrorTost, showSuccessTost } from 'src/constants';

const Settings = () => {
  const [loading, setLoading] = useState(false);
  const [settingId, setSettingId] = useState(null);
  const {
    handleSubmit,
    control,
    formState: { errors, isValid, isDirty },
    reset,
  } = useForm({
    resolver: yupResolver(updateSettingSchema),
    mode: 'onChange',
    defaultValues: {},
  });

  const getData = async () => {
    setLoading(true);
    try {
      let resp = await GET_SETTING();
      setSettingId(resp.data._id);
      // Ensure 0 values are properly handled by converting them to strings for display
      const formattedData = {
        cement: resp.data.cement?.toString() || '',
        sand: resp.data.sand?.toString() || '',
        gravel815: resp.data.gravel815?.toString() || '',
        gravel1525: resp.data.gravel1525?.toString() || '',
        taxRate: resp.data.taxRate?.toString() || '',
        bankName: resp.data.bankName || '',
        accountNumber: resp.data.accountNumber || '',
        accountName: resp.data.accountName || '',
      };
      reset(formattedData);
    } catch (error) {
      console.log(error.message);
    } finally {
      setLoading(false);
    }
  };

  const updateSetting = async (body) => {
    if (!settingId) {
      showErrorTost(t('taglines.settingNotLoaded'));
      return;
    }
    try {
      // Convert string values back to numbers for API submission
      const formattedBody = {
        ...body,
        cement: parseFloat(body.cement) || 0,
        sand: parseFloat(body.sand) || 0,
        gravel815: parseFloat(body.gravel815) || 0,
        gravel1525: parseFloat(body.gravel1525) || 0,
        taxRate: parseFloat(body.taxRate) || 0,
      };
      let resp = await UPDATE_SETTING(settingId, formattedBody);
      // Update the form with the response data
      const formattedData = {
        cement: resp.data.cement?.toString() || '',
        sand: resp.data.sand?.toString() || '',
        gravel815: resp.data.gravel815?.toString() || '',
        gravel1525: resp.data.gravel1525?.toString() || '',
        taxRate: resp.data.taxRate?.toString() || '',
        bankName: resp.data.bankName || '',
        accountNumber: resp.data.accountNumber || '',
        accountName: resp.data.accountName || '',
      };
      reset(formattedData);
      showSuccessTost(resp.message);
    } catch (error) {
      showErrorTost(error.message);
    }
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {loading ? (
        <Container
          sx={{ width: '100%', height: '70vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
        >
          <CircularProgress />
        </Container>
      ) : (
        <Container>
          <PageHeader pageTitle={t('navMenu.settings')} />
          <form onSubmit={handleSubmit(updateSetting)}>
            <Grid container xs={12} spacing={4} mt={2}>
              <Grid item xs={12} sm={6}>
                <CustomTextField
                  label={t('inventoryPage.cement')}
                  type="number"
                  controller={{
                    name: 'cement',
                    control: control,
                    errors: errors.cement,
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <CustomTextField
                  label={t('inventoryPage.sand')}
                  type="number"
                  controller={{
                    name: 'sand',
                    control: control,
                    errors: errors.sand,
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <CustomTextField
                  label={t('inventoryPage.gravel815')}
                  type="number"
                  controller={{
                    name: 'gravel815',
                    control: control,
                    errors: errors.gravel815,
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <CustomTextField
                  label={t('inventoryPage.gravel1525')}
                  type="number"
                  controller={{
                    name: 'gravel1525',
                    control: control,
                    errors: errors.gravel1525,
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <CustomTextField
                  label={t('settings.taxRate')}
                  type="number"
                  controller={{
                    name: 'taxRate',
                    control: control,
                    errors: errors.taxRate,
                  }}
                />
              </Grid>
              {/* <Grid item xs={12} sm={6}>
                <CustomTextField
                  label={t('bankDetails.bankName')}
                  controller={{
                    name: 'bankName',
                    control: control,
                    errors: errors.bankName,
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <CustomTextField
                  label={t('bankDetails.AccName')}
                  controller={{
                    name: 'accountName',
                    control: control,
                    errors: errors.accountName,
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <CustomTextField
                  label={t('bankDetails.AccNo')}
                  controller={{
                    name: 'accountNumber',
                    control: control,
                    errors: errors.accountNumber,
                  }}
                />
              </Grid> */}
              <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Grid item xs={2}>
                  <LoaderButton buttonText={t('common.save')} type="submit" disabled={!isValid || !isDirty} />
                </Grid>
              </Grid>
            </Grid>
          </form>
        </Container>
      )}
    </>
  );
};

export default Settings;
